// Splide Carousel init
// https://github.com/Splidejs/splide

(function (window) {
  'use strict';

  function initSliders() {
    var sliders = document.querySelectorAll('[data-slider]');
    sliders.forEach(function (slider) {
      new Splide(slider, {
        autoWidth: true,
        arrows: false,
        gap: 'var(--grid-gap)',
        padding: {
          left: 'var(--base-bleed1cols)',
          right: 'var(--base-bleed1cols)',
        },
        breakpoints: {
          800: {
            padding: {
              left: 'var(--base-bleed)',
              right: 'var(--base-bleed)',
            },
          },
        },
      }).mount();
    });
  }

  function initSliderStory() {
    var sliders = document.querySelectorAll('[data-sliderfigures]');
    sliders.forEach(function (slider) {
      new Splide(slider, {
        autoWidth: false,
        arrows: false,
        pagination: true,
      }).mount();
    });
  }

  function initMiniSliders() {
    var sliders = document.querySelectorAll('[data-miniSlider]');
    sliders.forEach(function (slider) {
      new Splide(slider, {
        autoWidth: true,
        arrows: false,
        gap: 'var(--grid-gap)',
        padding: {
          left: 'var(--base-bleed)',
          right: 'var(--base-bleed)',
        },
        mediaQuery: 'min',
        breakpoints: {
          1024: {
            destroy: true,
          },
        },
      }).mount();
    });
  }

  function initCarousels() {
    var carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(function (carousel) {
      new Splide(carousel, {
        autoWidth: true,
        autoplay: true,
        interval: 7000,
        arrows: false,
        pagination: false,
        padding: 'var(--splider-carousel-padding)',
        type: 'loop',
        gap: 'var(--grid-gap)',
      }).mount();
    });
  }

  initSliders();
  initSliderStory();
  initMiniSliders();
  initCarousels();
})(this);
